import { Alert } from '@aloft/toolkit-shared';

import { PropertyGridCellKey } from '../../components/PropertyGrid/types.ts';

export const getActiveAlertForPropertyGridCell = (
  alerts: Record<string, Alert[]>,
  cellKey: PropertyGridCellKey,
): Alert | undefined =>
  Object.values(alerts)
    .flat()
    .find((alert) => alert.status === 'active' && alert.fixingInfo.targetCellKey === cellKey);
